export default "__VITE_ASSET__DRQ_Ao64__"